/**
 * Addresses on the portal that the desktop app links out to.
 *
 * Shared so the two sides cannot drift apart: the desktop app ships on its own
 * release cadence, so a page renamed on the portal without the app following
 * leaves a link in the wizard 404ing silently, with nothing in either build to
 * catch it. One constant per address, imported by both.
 *
 * This is the portal's *public* origin, which is fixed. The API worker's view
 * of it is a separate, environment-configurable thing (`PORTAL_ORIGIN`), since
 * that one has to be localhost during development.
 */

/** Where the portal is published. */
export const PORTAL_URL = "https://bigbearbackup.com";

/** The route segment for the Backblaze setup guide, under `/help/`. */
export const BACKBLAZE_GUIDE_SLUG = "backblaze-b2";

/** The route segment for the guide about the two secrets that open a vault,
 * under `/help/`. Linked from every field in the app that handles one. */
export const SECRETS_GUIDE_SLUG = "recovery-key-and-passphrase";

/** The route segment for the "delete a vault by hand" guide, under `/help/`.
 * Linked from the desktop app's Delete dialog, by one of the anchors in
 * `vaultDeleteProviderNote.ts`. */
export const DELETE_VAULT_GUIDE_SLUG = "delete-a-vault-by-hand";

/** The full address of a Help guide, from its slug — the whole link, so a
 * caller never has to write half of it out again. */
export function helpGuideUrl(slug: string): string {
  return `${PORTAL_URL}/help/${slug}`;
}
